import ensurePath from 'redux/ensurePath'
import immerize from '../immerize'

function reducer(
  state = {
    status: '',
    error: null,
    user: {
      cardId: null,
      email: null,
      staffId: null,
      id: null,
      name: null,
      phoneNumber: null,
      isGroup: null,
      picture: {
        container: null,
        filename: null,
        link: null,
        id: null,
        imageableId: null,
      },
      updated: {
        uid: false,
        picture: false,
        link: false,
        contact: false,
        password: false,
      },
      status: {
        error: 'info',
        message: '',
      },
    },
    users: {
      admins: {
        byid: {},
        list: [],
        pagination: {
          count: 0,
          total: 0,
          currentPage: 1,
          itemPerPage: 10,
          pageCount: 1,
        },
      },
      officers: {
        byid: {},
        list: [],
        pagination: {
          count: 0,
          total: 0,
          currentPage: 1,
          itemPerPage: 10,
          pageCount: 1,
        },
      },
      marshals: {
        byid: {},
        list: [],
        pagination: {
          count: 0,
          total: 0,
          currentPage: 1,
          itemPerPage: 10,
          pageCount: 1,
        },
      },
    },
  },
  action
) {
  let data

  const targetUser = ensurePath(state, ['user'])

  switch (action.type) {
    case 'CLEAR_STORE':
      state = defaultState()
      break
    case 'ENDUSER_ONLINE_INFO':
      data = action.payload.data

      state.status = 'ENDUSER_ONLINE_INFO'
      state.error = data.error

      targetUser.cardId = data.cardId
      targetUser.staffId = data.staffId
      targetUser.name = data.name
      targetUser.phoneNumber = data.phoneNumber
      targetUser.isGroup = data.isGroup
      targetUser.email = data.email
      targetUser.picture = data.picture

      break
    case 'ENDUSERS_UPDATECARD_FULFILLED':
      state = endusersUpdateCardFulfilled(state, action.payload.data)
      break
    case 'ENDUSERS_UPDATECARD_REJECTED':
      state = endusersUpdateCardRejected(state, action.payload.data)
      break
    case 'ENDUSERS_CARDUIDALERT_DISMISSS':
      state = endusersUpdateCardDismissAlert(state)
      break
    case 'ENDUSERS_UPDATECONTACT_FULFILLED':
      state = endusersUpdateContactFulfilled(state, action.payload.data)
      break
    case 'ENDUSERS_UPDATECONTACT_REJECTED':
      state = endusersUpdateContactRejected(state, action.payload.data)
      break
    case 'ENDUSERS_CONTACTALERT_DISMISSS':
      state = endusersUpdateContactDismissAlert(state)
      break
    case 'ENDUSERS_PASSWORD_MISMATCHED':
      state = endusersPasswordMismatched(state)
      break
    case 'ENDUSERS_PASSWORD_LENGTH_ERR':
      state = endusersPasswordLengthErr(state)
      break
    case 'ENDUSERS_PASSWORDALERT_DISMISSS':
      state = endusersUpdatePasswordDismissAlert(state)
      break
    case 'ENDUSERS_PASSWORD_FULFILLED':
      state = endusersPasswordFulfilled(state)
      break
    case 'ENDUSERS_PASSWORD_REJECTED':
      state = endusersPasswordRejected(state, action.payload.data)
      break
    case 'ENDUSERS_UPDATE_PROFILEPIC':
      state = endusersUpdateProfilePic(state, action.payload)
      break
    case 'ENDUSERS_RESET_PROFILEPIC':
      state = endusersResetProfilePic(state)
      break
    case 'ENDUSERS_UPLOADPIC_REJECTED':
      state = endusersPictureUploadErr(state, 'Failed to upload picture')
      break
    case 'ENDUSERS_UPDATEPIC_REJECTED':
      state = endusersPictureUploadErr(state, 'Failed to update picture')
      break
    case 'ENDUSERS_UPDATEPIC_FULFILLED':
      state = endusersUpdatepicFulfilled(state, action.payload)
      break
    case 'ENDUSERS_PICTURE_DISMISSS':
      state = endusersUpdatePictureDismissAlert(state)
      break
    case 'ENDUSERS_USERLIST_FULFILLED':
      state = endusersUserlistFulfilled(state, action.payload)
      break
    case 'ENDUSERS_USERLIST_CLEAR':
      state = endusersUserlistClear(state)
      break
    case 'ENDUSERS_ADMINPAGECOUNT_CHANGE':
      state = endusersAdminPageCountChange(state, action.payload)
      break
    case 'ENDUSERS_ADMINPAGE_CHANGE':
      state = endusersAdminPageChange(state, action.payload)
      break
    case 'ENDUSERS_OFFICERPAGECOUNT_CHANGE':
      state = endusersOfficerPageCountChange(state, action.payload)
      break
    case 'ENDUSERS_OFFICERPAGE_CHANGE':
      state = endusersOfficerPageChange(state, action.payload)
      break
    case 'ENDUSERS_MARSHALPAGECOUNT_CHANGE':
      state = endusersMarshalPageCountChange(state, action.payload)
      break
    case 'ENDUSERS_MARSHALPAGE_CHANGE':
      state = endusersMarshalPageChange(state, action.payload)
      break
    case 'ENDUSERS_ADMINS_FILTERED':
      state = endusersAdminPagination(state, action.payload)
      break
    case 'ENDUSERS_OFFICERS_FILTERED':
      state = endusersOfficerPagination(state, action.payload)
      break
    case 'ENDUSERS_MARSHALS_FILTERED':
      state = endusersMarshalPagination(state, action.payload)
      break
    default:
      return state
  }
  return state
}

function defaultState() {
  return {
    status: '',
    error: null,
    user: {
      cardId: null,
      email: null,
      id: null,
      name: null,
      picture: {
        link: null,
      },
      updated: {
        uid: false,
        picture: false,
        link: false,
        contact: false,
        password: false,
      },
      status: {
        error: 'info',
        message: '',
      },
    },
    users: {
      admins: {
        byid: {},
        list: [],
        pagination: {
          count: 0,
          total: 0,
          currentPage: 1,
          itemPerPage: 10,
          pageCount: 1,
        },
      },
      officers: {
        byid: {},
        list: [],
        pagination: {
          count: 0,
          total: 0,
          currentPage: 1,
          itemPerPage: 10,
          pageCount: 1,
        },
      },
      marshals: {
        byid: {},
        list: [],
        pagination: {
          count: 0,
          total: 0,
          currentPage: 1,
          itemPerPage: 10,
          pageCount: 1,
        },
      },
    },
  }
}

function endusersUpdateCardFulfilled(state, card) {
  const targetUser = ensurePath(state, ['user'])
  const targetUserUpdated = ensurePath(state, ['user', 'updated'])

  targetUser.cardId = card.cardId
  targetUser.status = {
    error: 'info',
    message: 'Card UID successfully updated',
  }
  targetUserUpdated.uid = true
}
function endusersUpdateCardRejected(state, card) {
  const targetUser = ensurePath(state, ['user'])
  const targetUserUpdated = ensurePath(state, ['user', 'updated'])

  targetUser.status = {
    error: 'danger',
    message: `${card.error.name} : ${card.error.message}`,
  }
  targetUserUpdated.uid = true
}

function endusersUpdateContactFulfilled(state, contact) {
  const targetUser = ensurePath(state, ['user'])
  const targetUserUpdated = ensurePath(state, ['user', 'updated'])

  targetUser.phoneNumber = contact.phoneNumber
  targetUser.status = {
    error: 'info',
    message: 'Contact successfully updated',
  }
  targetUserUpdated.contact = true
}
function endusersUpdateContactRejected(state, contact) {
  const targetUser = ensurePath(state, ['user'])
  const targetUserUpdated = ensurePath(state, ['user', 'updated'])

  targetUser.status = {
    error: 'danger',
    message: `${contact.error.name} : ${contact.error.message}`,
  }
  targetUserUpdated.contact = true
}

function endusersPasswordMismatched(state) {
  const targetUser = ensurePath(state, ['user'])
  const targetUserUpdated = ensurePath(state, ['user', 'updated'])

  targetUser.status = {
    error: 'danger',
    message: 'Password mismatched',
  }
  targetUserUpdated.password = true
}
function endusersPasswordLengthErr(state) {
  const targetUser = ensurePath(state, ['user'])
  const targetUserUpdated = ensurePath(state, ['user', 'updated'])

  targetUser.status = {
    error: 'danger',
    message: 'Password length must be more than 6 characters',
  }
  targetUserUpdated.password = true
}

function endusersPasswordFulfilled(state) {
  const targetUser = ensurePath(state, ['user'])
  const targetUserUpdated = ensurePath(state, ['user', 'updated'])

  targetUser.status = {
    error: 'success',
    message: 'Password successfully updated',
  }
  targetUserUpdated.password = true
}
function endusersPasswordRejected(state, resp) {
  const targetUser = ensurePath(state, ['user'])
  const targetUserUpdated = ensurePath(state, ['user', 'updated'])

  targetUser.status = {
    error: 'danger',
    message: `${resp.error.name} : ${resp.error.message}`,
  }
  targetUserUpdated.password = true
}

function endusersUpdateCardDismissAlert(state) {
  const targetUserUpdated = ensurePath(state, ['user', 'updated'])
  targetUserUpdated.uid = false
}
function endusersUpdateContactDismissAlert(state) {
  const targetUserUpdated = ensurePath(state, ['user', 'updated'])
  targetUserUpdated.contact = false
}
function endusersUpdatePasswordDismissAlert(state) {
  const targetUserUpdated = ensurePath(state, ['user', 'updated'])
  targetUserUpdated.password = false
}
function endusersUpdatePictureDismissAlert(state) {
  const targetUserUpdated = ensurePath(state, ['user', 'updated'])
  targetUserUpdated.picture = false
}

function endusersUpdateProfilePic(state, pic) {
  const targetUserPicture = ensurePath(state, ['user', 'picture'])
  targetUserPicture.preview = pic
}
function endusersResetProfilePic(state) {
  const targetUserPicture = ensurePath(state, ['user', 'picture'])
  targetUserPicture.preview = null
}

function endusersUpdatepicFulfilled(state, result) {
  const targetUserPicture = ensurePath(state, ['user', 'picture'])
  const targetUserStatus = ensurePath(state, ['user', 'status'])
  const targetUserUpdated = ensurePath(state, ['user', 'updated'])

  targetUserPicture.filename = result.endusers.filename
  targetUserPicture.link = result.endusers.link

  targetUserStatus.error = 'success'
  targetUserStatus.message = 'Profile picture updated'
  targetUserUpdated.picture = true
}

function endusersPictureUploadErr(state, msg) {
  const targetUserStatus = ensurePath(state, ['user', 'status'])
  const targetUserUpdated = ensurePath(state, ['user', 'updated'])

  targetUserStatus.error = 'danger'
  targetUserStatus.message = msg

  targetUserUpdated.picture = true
}

function endusersUserlistFulfilled(state, newUsers) {
  const targetUsers = ensurePath(state, ['users'])

  if (typeof newUsers.admins !== 'undefined') {
    targetUsers.admins = normalizeAdmins(newUsers.admins)
  } else {
    targetUsers.admins = {
      byid: {},
      list: [],
      pagination: {
        count: 0,
        total: 0,
        currentPage: 1,
        itemPerPage: 10,
        pageCount: 1,
      },
    }
  }
  if (typeof newUsers.officers !== 'undefined') {
    targetUsers.officers = normalizeOfficers(newUsers.officers)
  } else {
    targetUsers.officers = {
      byid: {},
      list: [],
      pagination: {
        count: 0,
        total: 0,
        currentPage: 1,
        itemPerPage: 10,
        pageCount: 1,
      },
    }
  }

  if (typeof newUsers.marshals !== 'undefined') {
    targetUsers.marshals = normalizeMarshals(newUsers.marshals)
  } else {
    targetUsers.marshals = {
      byid: {},
      list: [],
      pagination: {
        count: 0,
        total: 0,
        currentPage: 1,
        itemPerPage: 10,
        pageCount: 1,
      },
    }
  }
}
function endusersUserlistClear(state) {
  state.users = {
    admins: {
      byid: {},
      list: [],
      pagination: {
        count: 0,
        total: 0,
        currentPage: 1,
        itemPerPage: 10,
        pageCount: 1,
      },
    },
    officers: {
      byid: {},
      list: [],
      pagination: {
        count: 0,
        total: 0,
        currentPage: 1,
        itemPerPage: 10,
        pageCount: 1,
      },
    },
    marshals: {
      byid: {},
      list: [],
      pagination: {
        count: 0,
        total: 0,
        currentPage: 1,
        itemPerPage: 10,
        pageCount: 1,
      },
    },
  }
}

function endusersAdminPageCountChange(state, count) {
  const targetUsersAdminsPagination = ensurePath(state, [
    'users',
    'admins',
    'pagination',
  ])
  const total = targetUsersAdminsPagination.total

  targetUsersAdminsPagination.itemPerPage = count
  targetUsersAdminsPagination.pageCount = Math.ceil(total / count)
  targetUsersAdminsPagination.currentPage = 1
}
function endusersAdminPageChange(state, index) {
  const targetUsersAdminsPagination = ensurePath(state, [
    'users',
    'admins',
    'pagination',
  ])

  targetUsersAdminsPagination.currentPage = index
}

function endusersOfficerPageCountChange(state, count) {
  const targetUsersOfficersPagination = ensurePath(state, [
    'users',
    'officers',
    'pagination',
  ])
  const total = targetUsersOfficersPagination.total

  targetUsersOfficersPagination.itemPerPage = count
  targetUsersOfficersPagination.pageCount = Math.ceil(total / count)
  targetUsersOfficersPagination.currentPage = 1
}
function endusersOfficerPageChange(state, index) {
  const targetUsersOfficersPagination = ensurePath(state, [
    'users',
    'officers',
    'pagination',
  ])

  targetUsersOfficersPagination.currentPage = index
}

function endusersMarshalPageCountChange(state, count) {
  const targetUsersMarshalsPagination = ensurePath(state, [
    'users',
    'marshals',
    'pagination',
  ])
  const total = targetUsersMarshalsPagination.total

  targetUsersMarshalsPagination.itemPerPage = count
  targetUsersMarshalsPagination.pageCount = Math.ceil(total / count)
  targetUsersMarshalsPagination.currentPage = 1
}
function endusersMarshalPageChange(state, index) {
  const targetUsersMarshalsPagination = ensurePath(state, [
    'users',
    'marshals',
    'pagination',
  ])
  targetUsersMarshalsPagination.currentPage = index
}

function endusersAdminPagination(state, total) {
  const targetUsersAdminsPagination = ensurePath(state, [
    'users',
    'admins',
    'pagination',
  ])

  targetUsersAdminsPagination.count = total
  targetUsersAdminsPagination.currentPage = 1
  targetUsersAdminsPagination.itemPerPage = 10
  targetUsersAdminsPagination.pageCount = Math.ceil(total / 10)
  targetUsersAdminsPagination.total = total
}
function endusersOfficerPagination(state, total) {
  const targetUsersOfficersPagination = ensurePath(state, [
    'users',
    'officers',
    'pagination',
  ])

  targetUsersOfficersPagination.count = total
  targetUsersOfficersPagination.currentPage = 1
  targetUsersOfficersPagination.itemPerPage = 10
  targetUsersOfficersPagination.pageCount = Math.ceil(total / 10)
  targetUsersOfficersPagination.total = total
}
function endusersMarshalPagination(state, total) {
  const targetUsersMarshalsPagination = ensurePath(state, [
    'users',
    'marshals',
    'pagination',
  ])

  targetUsersMarshalsPagination.count = total
  targetUsersMarshalsPagination.currentPage = 1
  targetUsersMarshalsPagination.itemPerPage = 10
  targetUsersMarshalsPagination.pageCount = Math.ceil(total / 10)
  targetUsersMarshalsPagination.total = total
}

/**
 * ---------------------------------------------------------
 * Utils
 * ---------------------------------------------------------
 */

function normalizeAdmins(admins) {
  const _admins = {
    byid: {},
    list: [],
    pagination: {
      count: admins.length,
      total: admins.length,
      currentPage: 1,
      itemPerPage: 10,
      pageCount: Math.ceil(admins.length / 10),
    },
  }
  admins.forEach((admin) => {
    _admins.byid[admin.id] = admin
    _admins.list.push(admin.id)
  })
  return _admins
}
function normalizeOfficers(officers) {
  const _officers = {
    byid: {},
    list: [],
    pagination: {
      count: officers.length,
      total: officers.length,
      currentPage: 1,
      itemPerPage: 10,
      pageCount: Math.ceil(officers.length / 10),
    },
  }
  officers.forEach((officer) => {
    _officers.byid[officer.id] = officer
    _officers.list.push(officer.id)
  })
  return _officers
}
function normalizeMarshals(marshals) {
  const _marshals = {
    byid: {},
    list: [],
    pagination: {
      count: marshals.length,
      total: marshals.length,
      currentPage: 1,
      itemPerPage: 10,
      pageCount: Math.ceil(marshals.length / 10),
    },
  }
  marshals.forEach((marshal) => {
    _marshals.byid[marshal.id] = marshal
    _marshals.list.push(marshal.id)
  })
  return _marshals
}

export default immerize(reducer)
